customElements.get("upsell-product-form") ||
  customElements.define(
    "upsell-product-form",
    class extends HTMLElement {
      constructor() {
        (super(),
          (this.form = this.querySelector("form")),
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
          (this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer")),
          (this.submitButton = this.querySelector('[type="submit"]')),
          this.submitButton.setAttribute("aria-haspopup", "dialog"),
          (this.submitButtonText = this.submitButton.querySelector("span")),
          (this.replaceProduct = this.dataset.replaceProduct));
      }
      async onSubmitHandler(t) {
        if (
          (t.preventDefault(),
          "true" === this.submitButton.getAttribute("aria-disabled"))
        )
          return;
        let s = Debutify.cart.items.find(
          (t) => t.handle == this.replaceProduct,
        );
        if (s)
          try {
            const t = { id: s.key, quantity: 0 };
            await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(t),
            })
              .then((t) => t.json())
              .then(() => {});
          } catch (t) {
            ((e.target.disabled = !1), console.error("Error:", t));
          }
        (this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.querySelector(".loading__spinner").classList.remove("hidden"));
        const r = fetchConfig("javascript");
        ((r.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete r.headers["Content-Type"]);
        const i = new FormData(this.form);
        console.log(i);
        (this.cart &&
          (i.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id),
          ),
          i.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement)),
          (r.body = i),
          fetch(`${routes.cart_add_url}`, r)
            .then((t) => t.json())
            .then((t) => {
              if (t.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: i.get("id"),
                  errors: t.errors || t.description,
                  message: t.message,
                });
                const e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                return (
                  this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButtonText.classList.add("hidden"),
                  e.classList.remove("hidden"),
                  void (this.error = !0)
                );
              }
              this.cart
                ? (this.error ||
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: "product-form",
                      productVariantId: i.get("id"),
                      cartData: t,
                    }),
                  (this.error = !1),
                  this.cart.renderContents(t))
                : (window.location = window.routes.cart_url);
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(() => {
              (this.submitButton.classList.remove("loading"),
                this.cart &&
                  this.cart.classList.contains("is-empty") &&
                  this.cart.classList.remove("is-empty"),
                this.error ||
                  this.submitButton.removeAttribute("aria-disabled"),
                this.querySelector(".loading__spinner").classList.add(
                  "hidden",
                ));
            }));
      }
    },
  );
